module.exports = __webpack_public_path__ + "img/Perks-35.074f7aa1.png";